var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "Dots list-unstyled"
  }, _vm._l(_vm.steps, function (step, index) {
    return _c('li', {
      key: ("dot_" + index),
      staticClass: "Dots-dot",
      class: _vm.getClasses(index),
      attrs: {
        "tabindex": _vm.globalTabIndex
      },
      on: {
        "click": function ($event) {
          return _vm.dotClicked(index);
        },
        "keyup": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.dotClicked(index);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
          return _vm.dotClicked(index);
        }]
      }
    });
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }